import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { LucideIcon, TrendingUp, TrendingDown } from "lucide-react";
import { KPITooltip } from "./KPITooltip";

interface KPICardProps {
	title: string;
	value: string | number;
	subtitle?: string;
	icon: LucideIcon;
	color?: string;
	trend?: "up" | "down";
	tooltip?: string;
}

export function KPICard({ title, value, subtitle, icon: Icon, color = "bg-blue-50 text-blue-500", trend, tooltip }: KPICardProps) {
	return (
		<Card>
			<CardHeader className="pb-2">
				<div className="flex justify-between items-start">
					<div className={cn("p-2 rounded-sm", color)}>
						<Icon className="h-5 w-5" />
					</div>
					<div className="flex items-center gap-2">
						{tooltip && <KPITooltip text={tooltip} />}
						{trend && (
							<div className={cn("flex items-center text-sm", trend === "up" ? "text-green-600" : "text-red-600")}>
								{trend === "up" ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
							</div>
						)}
					</div>
				</div>
			</CardHeader>
			<CardContent>
				<div className="text-3xl font-semibold mb-1">{value}</div>
				<p className="text-sm font-medium text-muted-foreground">{title}</p>
				{subtitle && (
					<p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
				)}
			</CardContent>
		</Card>
	);
}
